import { render, staticRenderFns } from "./ChatOrderProfileModalDetail.vue?vue&type=template&id=6005301a&scoped=true&"
import script from "./ChatOrderProfileModalDetail.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileModalDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileModalDetail.vue?vue&type=style&index=0&id=6005301a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005301a",
  null
  
)

export default component.exports